import React, { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function BannerStrip({ variant = "portada" }) {
  const { user } = useAuth();
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    if (user && user.is_premium) {
      setBanners([]);
      return;
    }
    api.get("/banners").then((r) => setBanners(r.data)).catch(() => setBanners([]));
  }, [user]);

  if (!banners.length) return null;
  const banner = banners[0];

  return (
    <div className="border-t border-b border-[#E2E8F0] bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex items-center gap-4">
        <span className="text-[10px] font-mono uppercase tracking-[0.16em] text-[#64748B] hidden sm:inline">
          Publicidad
        </span>
        <a
          href={banner.target_url}
          target="_blank"
          rel="noreferrer noopener nofollow"
          data-testid={`banner-${banner.id}`}
          className="flex-1 flex items-center gap-4 group"
        >
          <div className="w-28 h-14 sm:w-40 sm:h-16 bg-[#EEF2F7] overflow-hidden flex-shrink-0">
            {banner.image && (
              <img
                src={fileUrl(banner.image)}
                alt={banner.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-serif text-lg sm:text-xl font-semibold text-[#1A1A1A] truncate group-hover:text-[#3B5FB8] transition-colors">
              {banner.title}
            </p>
            {banner.subtitle && <p className="text-xs text-[#475569] truncate">{banner.subtitle}</p>}
          </div>
          <span className="text-[11px] font-mono uppercase tracking-widest text-[#3B5FB8] hidden sm:inline">
            Ver más →
          </span>
        </a>
      </div>
    </div>
  );
}
